export default __webpack_public_path__ + "static/media/day21.c7ffb62d.png";